/**
 * @generated SignedSource<<fb4d3561098c319ff4ff412ffdc08e6d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchCombinationType = "AND" | "OR" | "%future added value";
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchParticipantType = "COMMENTED" | "CONTRIBUTOR" | "MENTIONS" | "PRESENCE" | "SHARED" | "VIEWED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchResults_AtlassianSearchPage_SearchResultsBody_connectionData$data = {
  readonly autoAppliedFilters?: {
    readonly commonFilters: {
      readonly participants: {
        readonly combination: SearchCombinationType;
        readonly items: ReadonlyArray<{
          readonly combination: SearchCombinationType;
          readonly type: SearchParticipantType;
          readonly users: ReadonlyArray<string>;
        }> | null | undefined;
      } | null | undefined;
      readonly range: {
        readonly lastModified: {
          readonly gt: string | null | undefined;
          readonly lt: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly __typename: string;
      readonly connectorId?: string | null | undefined;
      readonly connectorProduct?: string | null | undefined;
      readonly connectorType?: string | null | undefined;
      readonly description: string;
      readonly id: string;
      readonly integrationId?: string | null | undefined;
      readonly issue?: {
        readonly webUrl: AGG$URL | null | undefined;
      } | null | undefined;
      readonly linkedResults: ReadonlyArray<{
        readonly category: SearchLinkedResultCategory;
        readonly connectorType: string | null | undefined;
        readonly id: string;
      }> | null | undefined;
      readonly ownerId?: string | null | undefined;
      readonly providerId?: string | null | undefined;
      readonly socialSignal?: {
        readonly signal: string | null | undefined;
      } | null | undefined;
      readonly url?: string;
      readonly " $fragmentSpreads": FragmentRefs<"searchResult_AtlassianSearchPage">;
    } | null | undefined;
  }>;
  readonly errors: ReadonlyArray<{
    readonly integration: string | null | undefined;
    readonly product: string | null | undefined;
    readonly statusCode: number;
  }> | null | undefined;
  readonly queryInfo: {
    readonly originalQuery: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"autoCorrection_AtlassianSearchPage">;
  } | null | undefined;
  readonly totalCounts?: ReadonlyArray<{
    readonly count: number;
    readonly product: string;
  }>;
  readonly traceId: string | null | undefined;
  readonly " $fragmentType": "searchResults_AtlassianSearchPage_SearchResultsBody_connectionData";
};
export type searchResults_AtlassianSearchPage_SearchResultsBody_connectionData$key = {
  readonly " $data"?: searchResults_AtlassianSearchPage_SearchResultsBody_connectionData$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchResults_AtlassianSearchPage_SearchResultsBody_connectionData">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "connectorType"
},
v2 = {
  "kind": "ScalarField",
  "name": "combination"
},
v3 = {
  "kind": "ScalarField",
  "name": "product"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__isassetsenabledrelayprovider"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeAssigneeField"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeAutoAppliedFilters"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeIconUrl"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeIssueTypeField"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeNavBoostScore"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePassionfruitAsk"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePositions"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeThirdPartyId"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeTotalCounts"
    },
    {
      "kind": "RootArgument",
      "name": "tenantId"
    }
  ],
  "kind": "Fragment",
  "name": "searchResults_AtlassianSearchPage_SearchResultsBody_connectionData",
  "selections": [
    {
      "concreteType": "SearchResultItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__typename"
            },
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "description"
            },
            {
              "concreteType": "SearchLinkedResult",
              "kind": "LinkedField",
              "name": "linkedResults",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "category"
                },
                (v1/*: any*/)
              ]
            },
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "includeAssets",
                  "variableName": "__relay_internal__pv__isassetsenabledrelayprovider"
                },
                {
                  "kind": "Variable",
                  "name": "includeAssigneeField",
                  "variableName": "includeAssigneeField"
                },
                {
                  "kind": "Variable",
                  "name": "includeIconUrl",
                  "variableName": "includeIconUrl"
                },
                {
                  "kind": "Variable",
                  "name": "includeIssueTypeField",
                  "variableName": "includeIssueTypeField"
                },
                {
                  "kind": "Variable",
                  "name": "includeNavBoostScore",
                  "variableName": "includeNavBoostScore"
                },
                {
                  "kind": "Variable",
                  "name": "includePassionfruitAsk",
                  "variableName": "includePassionfruitAsk"
                },
                {
                  "kind": "Variable",
                  "name": "includePositions",
                  "variableName": "includePositions"
                },
                {
                  "kind": "Variable",
                  "name": "includeThirdPartyId",
                  "variableName": "includeThirdPartyId"
                }
              ],
              "kind": "FragmentSpread",
              "name": "searchResult_AtlassianSearchPage"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "providerId"
                },
                {
                  "kind": "ScalarField",
                  "name": "integrationId"
                },
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "connectorId"
                },
                {
                  "kind": "ScalarField",
                  "name": "connectorProduct"
                }
              ],
              "type": "SearchResultGraphDocument"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "ownerId"
                }
              ],
              "type": "SearchResultCompassComponent"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "url"
                },
                {
                  "concreteType": "JiraIssue",
                  "kind": "LinkedField",
                  "name": "issue",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "webUrl"
                    }
                  ]
                }
              ],
              "type": "SearchResultJiraIssue"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "tenantId",
                      "variableName": "tenantId"
                    }
                  ],
                  "concreteType": "SocialSignalSearch",
                  "kind": "LinkedField",
                  "name": "socialSignal",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "signal"
                    }
                  ]
                }
              ],
              "type": "SearchConfluencePageBlogAttachment"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "SearchQueryInfo",
      "kind": "LinkedField",
      "name": "queryInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "originalQuery"
        },
        {
          "kind": "FragmentSpread",
          "name": "autoCorrection_AtlassianSearchPage"
        }
      ]
    },
    {
      "condition": "includeAutoAppliedFilters",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "SearchFilterOutput",
          "kind": "LinkedField",
          "name": "autoAppliedFilters",
          "plural": false,
          "selections": [
            {
              "concreteType": "SearchCommonFilterOutput",
              "kind": "LinkedField",
              "name": "commonFilters",
              "plural": false,
              "selections": [
                {
                  "concreteType": "SearchCommonRangeFilterOutput",
                  "kind": "LinkedField",
                  "name": "range",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "SearchCommonRangeFilterFieldsOutput",
                      "kind": "LinkedField",
                      "name": "lastModified",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "gt"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "lt"
                        }
                      ]
                    }
                  ]
                },
                {
                  "concreteType": "SearchParticipantsOutput",
                  "kind": "LinkedField",
                  "name": "participants",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "SearchParticipantOutput",
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "type"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "users"
                        },
                        (v2/*: any*/)
                      ]
                    },
                    (v2/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "traceId"
    },
    {
      "concreteType": "SearchError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "statusCode"
        },
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "integration"
        }
      ]
    },
    {
      "condition": "includeTotalCounts",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "SearchProductCount",
          "kind": "LinkedField",
          "name": "totalCounts",
          "plural": true,
          "selections": [
            (v3/*: any*/),
            {
              "kind": "ScalarField",
              "name": "count"
            }
          ]
        }
      ]
    }
  ],
  "type": "SearchItemConnection"
};
})();

(node as any).hash = "32e55a5a474872414af2f0a2cefc3e81";

export default node;
